export default "__VITE_ASSET__DPhtK7iC__"